import { render, staticRenderFns } from "./SettingsClinicalUsersForm.vue?vue&type=template&id=8acda7a0&scoped=true"
import script from "./SettingsClinicalUsersForm.vue?vue&type=script&lang=js"
export * from "./SettingsClinicalUsersForm.vue?vue&type=script&lang=js"
import style0 from "./SettingsClinicalUsersForm.vue?vue&type=style&index=0&id=8acda7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acda7a0",
  null
  
)

export default component.exports